/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Attributes_Apply_ButtonInputs */

const en_paste_attributes_apply_button = /** @type {(inputs: Paste_Attributes_Apply_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply`)
};

const fr_paste_attributes_apply_button = /** @type {(inputs: Paste_Attributes_Apply_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appliquer`)
};

const de_paste_attributes_apply_button = /** @type {(inputs: Paste_Attributes_Apply_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anwenden`)
};

const it_paste_attributes_apply_button = /** @type {(inputs: Paste_Attributes_Apply_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fare domanda a`)
};

const ru_paste_attributes_apply_button = /** @type {(inputs: Paste_Attributes_Apply_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Применять`)
};

const es_paste_attributes_apply_button = /** @type {(inputs: Paste_Attributes_Apply_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar`)
};

const zh_cn2_paste_attributes_apply_button = /** @type {(inputs: Paste_Attributes_Apply_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`申请`)
};

const ja_paste_attributes_apply_button = /** @type {(inputs: Paste_Attributes_Apply_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`適用する`)
};

const hi_paste_attributes_apply_button = /** @type {(inputs: Paste_Attributes_Apply_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आवेदन करना`)
};

const pt_pt2_paste_attributes_apply_button = /** @type {(inputs: Paste_Attributes_Apply_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar`)
};

/**
* | output |
* | --- |
* | "Apply" |
*
* @param {Paste_Attributes_Apply_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_attributes_apply_button = /** @type {((inputs?: Paste_Attributes_Apply_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Attributes_Apply_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_paste_attributes_apply_button(inputs)
	if (locale === "de") return de_paste_attributes_apply_button(inputs)
	if (locale === "it") return it_paste_attributes_apply_button(inputs)
	if (locale === "ru") return ru_paste_attributes_apply_button(inputs)
	if (locale === "es") return es_paste_attributes_apply_button(inputs)
	if (locale === "zh-CN") return zh_cn2_paste_attributes_apply_button(inputs)
	if (locale === "ja") return ja_paste_attributes_apply_button(inputs)
	if (locale === "hi") return hi_paste_attributes_apply_button(inputs)
	if (locale === "pt-PT") return pt_pt2_paste_attributes_apply_button(inputs)
	return en_paste_attributes_apply_button(inputs)
});